

export const StorySector=()=>{
    return(
        <div className="story-sector">
            <div className="__container">
                <div className='story-sector_row'>
                    <div className="story-sector_colmun-gif">
                        <div className="story-sector_header"><h1>the story behind the souce</h1></div>
                        <div className="story-sector_gif"><img src={require('../../../../static/image 1-mainPage-gif.jpg')}/></div>
                    </div>
                    <div className="story-sector_colmun">
                        
                        <div className='story-sector-colmun-content'>
                            <p>HELLO, I’M LAUREN AND AS A LIFELONG ADVENTUROUS EATER, I’VE TRIED A LOT OF CRAZY THINGS, BUT I NEVER THOUGHT HOT SAUCE IN COFFEE WAS A SANE OPTION UNTIL A FRIEND DARED ME TO TRY IT.</p>
                            <span>AND IT SUCKED.</span>
                            <p>BUT I WONDERED IF THERE WAS A WAY TO ADD SPICE TO MY COFFEE. WHEN THERE WAS NO EASY SOLUTION, UJJO WAS BORN.</p>
                            <span>UJJO (OOO-JOE): THE WORD FOR “FIRE” IN KONKANI, SPOKEN ON THE WEST COAST OF INDIA, IS AN HOMAGE AND A LOVE LETTER TO MY DAD, AN INDIAN IMMIGRANT WHO INSTILLED A FIRE IN MY PALATE – AND MY HEART – FROM THE VERY BEGINNING.</span>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    )
}